import * as React from 'react';
import styled from 'styled-components';
import { HelpText } from '../onlineForm/onlineForm';
import starLeftHalfFull from '../../assets/apply-online/starLeftHalfFull.svg';
import starRightHalfFull from '../../assets/apply-online/starRightHalfFull.svg';
import starLeftHalfEmpty from '../../assets/apply-online/starLeftHalfEmpty.svg';
import starRightHalfEmpty from '../../assets/apply-online/starRightHalfEmpty.svg';

// ############################ Styles ###########################
// tslint:disable:variable-name

const drawStars = (rank: number, size: StarSize) => {
  const starHeight = size === StarSize.Large ? '40px' : '20px';

  return (
    <>
      {[...Array(5)].map((x, i) => {
        return (
          <span key={i}>
            {rank >= i / 2 + 0.7 ? (
              <SStarLeftHalfFull src={starLeftHalfFull} size={starHeight} />
            ) : (
              <SStarLeftHalfEmpty src={starLeftHalfEmpty} size={starHeight} />
            )}
            {rank >= i + 0.7 ? (
              <SStarRightHalfFull src={starRightHalfFull} size={starHeight} />
            ) : (
              <SStarRightHalfEmpty src={starRightHalfEmpty} size={starHeight} />
            )}
          </span>
        );
      })}
    </>
  );
};

const SRank = styled.div(
  ({ theme }) => `
  padding-bottom: 30px;
  `
);

const SStarLeftHalfFull = styled.img<{ size: string }>(({ theme, size }) => {
  return `
        height: ${size};
    `;
});

const SStarLeftHalfEmpty = styled.img<{ size: string }>(({ theme, size }) => {
  return `
        height: ${size};
    `;
});

const SStarRightHalfFull = styled.img<{ size: string }>(({ theme, size }) => {
  return `
        height: ${size};
        margin-left: -1px;
        margin-right: 3px;
    `;
});

const SStarRightHalfEmpty = styled.img<{ size: string }>(({ theme, size }) => {
  return `
        height: ${size};
        margin-left: -1px;
        margin-right: 3px;
    `;
});

const STitle = styled(HelpText)(({ theme }) => {
  return `
        padding: 10px;
        text-align: left;
        @media only screen and ${theme.device.max.laptopS} {
          flex-direction: column;
          text-align: center;
        }
    `;
});

// tslint:enable:variable-name
// ############################ End Styles ###########################

export enum StarSize {
  Large = 'large',
  Small = 'small',
}

export interface IRankProps {
  title: string;
  rank: number;
  size: StarSize;
}

export default (props: IRankProps) => {
  return (
    <SRank>
      <span>{drawStars(props.rank, props.size)}</span>
      <STitle>{props.title}</STitle>
    </SRank>
  );
};
